<template>
  <div class="container">
    <h1 style="text-align:center;">ניהול קליטת עובד קבלן</h1>
    <div class="warpper">
      <div class="field">
        <p>שם פרטי</p>
        <InputText
          v-model="values.firstName"
          type="text"
          placeholder="שם פרטי"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p>שם משפחה</p>
        <InputText
          v-model="values.lastName"
          type="text"
          placeholder="שם משפחה"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p>תעודת זהות/דרכון</p>
        <InputText
          v-model="values.idOrPassport"
          type="text"
          placeholder="ת.ז. או דרכון"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p>תאריך לידה</p>
        <IlDateInput v-model="values.birthDate" />
        <small class="date-hint" v-if="values.birthDate">{{ format_date_il(values.birthDate) }}</small>
      </div>
      <div class="field">
        <p>נייד</p>
        <InputText
          v-model="values.mobile"
          type="text"
          placeholder="05XXXXXXXX"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p>תפקיד מיועד</p>
        <InputText
          v-model="values.role"
          type="text"
          placeholder="תפקיד"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p>שיוך לסניף</p>
        <Dropdown
          v-model="values.branch"
          :options="branchesOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="נא לבחור סניף"
          style="width:100%"
          :disabled="!branchesLoaded || branchesOptions.length === 0"
          filter
        />
        <small v-if="branchesOptions.length === 0 && branchesLoaded" style="color: red;">
          לא נמצאו סניפים
        </small>
      </div>
      <div class="field">
        <p>תאריך תחילת עבודה</p>
        <IlDateInput v-model="values.startDate" />
        <small class="date-hint" v-if="values.startDate">{{ format_date_il(values.startDate) }}</small>
      </div>
      <div class="field">
        <p>שם חברת הקבלן</p>
        <InputText
          v-model="values.contractorCompany"
          type="text"
          placeholder="חברת קבלן"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p>שם פותח/ת הבקשה</p>
        <InputText
          v-model="values.ownerName"
          type="text"
          placeholder="שם פותח הבקשה"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p>דוא"ל לעדכון התהליך</p>
        <InputText
          v-model="values.email"
          type="text"
          placeholder="דואל"
          style="width:100%"
        />
      </div>

      <!-- Upload Additional Documents Section -->
      <div class="field">
        <p>הוסף מסמכים נוספים - {{ values.uploadedDocuments?.length || 0 }}/5 מסמכים</p>
        <Button
          v-if="!isPending"
          label="צירף תמונה/מסמך"
          class="p-button-secondary upload-btn"
          :disabled="(values.uploadedDocuments?.length || 0) >= 5"
          @click="handleUpload"
        />
        <Button
          v-if="isPending"
          label="ממתין להעלאה..."
          class="p-button-secondary upload-btn"
          disabled
        />
        <input
          v-show="false"
          id="upload-image-admin"
          type="file"
          accept="image/png,image/jpeg,image/jpg,image/heic,application/pdf"
          @change="handleChange"
        />
        <div v-if="fileError" style="color:red; margin-top: 5px;">{{ fileError }}</div>
      </div>

      <!-- Uploaded Documents Display -->
      <div class="field" v-if="values.uploadedDocuments && values.uploadedDocuments.length > 0">
        <p>מסמכים מצורפים ({{ values.uploadedDocuments.length }})</p>
        <div class="images">
          <template
            v-for="document in values.uploadedDocuments"
            :key="document.filePath"
          >
            <div class="image">
              <img
                v-if="document.type != 'application/pdf'"
                :src="document.url"
                @click="handleOpenDocument(document)"
              />
              <img
                v-if="document.type == 'application/pdf'"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png"
                @click="handleOpenDocument(document)"
              />
              <div class="delete-bar" @click="delete_file(document)">
                <p>מחק</p>
              </div>
            </div>
          </template>
        </div>
      </div>

      <!-- Admin-editable fields -->
      <div class="field">
        <p style="color:red;">מטופל ע"י</p>
        <Dropdown
          :options="chargeOptions"
          v-model="values.charge"
          placeholder="מטופל על ידי"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p style="color:red;">סטטוס</p>
        <Dropdown
          :options="statusOptions"
          v-model="values.status"
          placeholder="סטטוס טיפול"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p style="color:red;">הודעה לסניף</p>
        <Textarea
          v-model="values.msg"
          rows="5"
          cols="30"
          placeholder="הודעה זו תשלח בגוף המייל לפותח הבקשה"
        />
      </div>
    </div>
    <Button
      label="עדכן"
      class="p-button-success send-btn"
      @click="handleSubmit"
    />
    <Loader v-if="isPending" />
  </div>

  <!-- JUST FOR MAIL -->
  <div class="form-email" id="form-email" v-show="false">
    <table
      style="width:50%; border-collapse: collapse; font-size: 1.1rem; margin: 1rem 0;"
    >
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          תאריך הבקשה
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ format_date_time_il(values.createdAt) }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding:8px;">
          שם הסניף השולח
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding:8px;">
          {{ values.branche }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          סוג הבקשה
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.type }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          שם פרטי
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.firstName }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          שם משפחה
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.lastName }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          תעודת זהות/דרכון
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.idOrPassport }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          תאריך לידה
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ format_date_il(values.birthDate) }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          נייד
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.mobile }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          תפקיד מיועד
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.role }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          שיוך לסניף
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.branch }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          תאריך תחילת עבודה
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ format_date_il(values.startDate) }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          שם חברת הקבלן
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.contractorCompany }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          שם פותח הבקשה
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.ownerName }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          אימייל לעדכון סטטוס וקבלת עדכונים
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.email }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          סטטוס
        </th>
        <td
          style="border:1px solid #dddddd; text-align:right; padding: 8px; color:green"
        >
          {{ values.status }}
        </td>
      </tr>
      <tr v-if="values.msg">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          הערות
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.msg }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
/* eslint-disable */
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import Dropdown from "primevue/dropdown";
import swal from "sweetalert";
import {projectFirestore, projectFunctions} from '@/firebase/config'
import { onMounted, ref } from "vue";
import {update_status_counter, convert_type_he_to_en} from '@/Methods/office_request_funcs'
import use_office_requests_storage from '@/Methods/use_office_requests_storage'
import router from '../../../../../../router';
import Loader from '../loader/Loader.vue'
import { format_date_il, format_date_time_il } from '@/Methods/Dates'
import IlDateInput from '@/components/Applications/officeRequests/components/inputs/IlDateInput.vue'

export default {
  components: { IlDateInput, InputText, Textarea, Dropdown, Loader },
  props: ['docId', 'data'],

  setup(props) {
    const chargeOptions = ref([
      'שירז',
      'אירה',
      'עדי',
      'יעל',
      'מירה'
    ]);

    const statusOptions = ref([
      'חדש',
      'ממתין',
      'טופל'
    ]);

    const branchesOptions = ref([]);
    const branchesLoaded = ref(false);

    const { url, filePath, uploadImage, deleteImage } = use_office_requests_storage();
    const isPending = ref(false);
    const file = ref(null);
    const fileError = ref(null);
    const error = ref("");
    const old_status = ref();

    const values = ref({});

    const handleOpenDocument = document => {
      window.open(document.url, "_blank");
    };

    const handleUpload = () => {
      document.getElementById("upload-image-admin").click();
    };

    const handleChange = async e => {
      isPending.value = true;
      const types = ["image/png", "image/jpeg", "image/jpg", "image/heic", "application/pdf"];
      const selected = e.target.files[0];

      if (selected && types.includes(selected.type)) {
        file.value = selected;
        fileError.value = null;

        // Initialize uploadedDocuments if undefined
        if (!values.value.uploadedDocuments) {
          values.value.uploadedDocuments = [];
        }

        if (values.value.uploadedDocuments.length < 5) {
          await uploadImage(file.value, "Contractor_Employee");
          values.value.uploadedDocuments.push({
            url: url.value,
            filePath: filePath.value,
            type: selected.type
          });
        }
      } else {
        console.log("error");
        file.value = null;
        fileError.value = "סוג קובץ זה אינו נתמך, נא להעלות JPG, PNG, HEIC או PDF בלבד!";
      }
      isPending.value = false;
      // Reset input so same file can be selected again
      e.target.value = '';
    };

    const delete_file = async document => {
      const index = values.value.uploadedDocuments.findIndex(
        doc => doc.filePath === document.filePath
      );
      if (index > -1) {
        values.value.uploadedDocuments.splice(index, 1);
        await deleteImage(document.filePath);
      }
    };

    const validation = () => {
      // Basic validation for required fields
      if (!values.value.firstName || values.value.firstName.length === 0) {
        error.value = "נא למלא שם פרטי";
        return false;
      }
      if (!values.value.lastName || values.value.lastName.length === 0) {
        error.value = "נא למלא שם משפחה";
        return false;
      }
      if (!values.value.idOrPassport ||
          values.value.idOrPassport.length < 8 ||
          values.value.idOrPassport.length > 9 ||
          !/^[A-Za-z0-9]+$/.test(values.value.idOrPassport)) {
        error.value = "נא למלא תעודת זהות או דרכון תקין (8-9 תווים)";
        return false;
      }
      if (!values.value.email || values.value.email.length === 0 || !values.value.email.includes("@")) {
        error.value = "נא למלא כתובת מייל תקינה";
        return false;
      }
      return true;
    };

    const handleSubmit = async () => {
      if (!validation()) {
        swal("בעיה", `${error.value}`, "warning");
      } else {
        try {
          delete values.value.createdAt;
          const request_collection = convert_type_he_to_en(values.value.type);

          await projectFirestore
            .collection('Applications')
            .doc(props.docId)
            .collection(request_collection)
            .doc(values.value.id)
            .set(values.value, {merge: true});

          // Update status counters if status changed
          if (old_status.value !== values.value.status) {
            await update_status_counter(old_status.value, values.value.status, props.docId);
          }

          sendEmailToUser();
          swal("הצלחה", "הטופס עודכן בהצלחה", "success");
          router.go(-1);
        } catch (err) {
          console.error(err);
          swal("שגיאה", "אירעה שגיאה בעדכון הטופס", "error");
        }
      }
    };

    function sendEmailToUser() {
      projectFunctions.httpsCallable('send_email')({
        html: `<div>
                <h3>
                    שלום ${values.value.ownerName},
                </h3>
                <h3>
                    בקשתך לקליטת עובד קבלן: ${values.value.firstName} ${values.value.lastName}
                </h3>
                <h3>
                    עבור: ${values.value.type}
                </h3>
                <h3>
                    לסניף/אתר ${values.value.branche}
                </h3>
                <h3>
                    בסטטוס ${values.value.status}
                </h3>
                <h3>
                    הערות: ${values.value.msg || 'אין הערות'}
                </h3>
                <h3 style="color:red;">
                    נא לשים לב להמשך עדכונים שיתקבלו אוטמטית מהמערכת בכל שלבי הטיפול!
                </h3>
            </div>`,
        destinations: [`${values.value.email}`],
        from: "מערכת לבקשות משרדיות",
        title: "עדכון סטטוס בקשה משרדית - קליטת עובד קבלן"
      });
    }

    const fetchBranches = async () => {
      try {
        const snapshot = await projectFirestore
          .collection('Shivuk')
          .doc('Shivuk')
          .collection('Branches')
          .get();

        branchesOptions.value = snapshot.docs.map(doc => ({
          label: doc.data().name,
          value: doc.data().name
        }));
        branchesLoaded.value = true;
      } catch (err) {
        console.error('Error fetching branches:', err);
        branchesOptions.value = [];
        branchesLoaded.value = true;
      }
    };

    onMounted(() => {
      fetchBranches();
      isPending.value = true;
      setTimeout(() => {
        if (props.data) {
          values.value = props.data;
          old_status.value = values.value.status;
          isPending.value = false;
        }
      }, 1000);
    });

    return {
      format_date_il,
      format_date_time_il,
      values,
      error,
      handleSubmit,
      isPending,
      statusOptions,
      chargeOptions,
      branchesOptions,
      branchesLoaded,
      handleOpenDocument,
      handleUpload,
      handleChange,
      delete_file,
      fileError
    };
  }
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.warpper {
  width: 50%;
  height: calc(100% - 100px);
  border: 1px solid black;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
}
.field {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
  margin-top: 15px;
}
.field p {
  font-size: 1.1rem;
}
.send-btn {
  margin-top: 5px;
  width: 50%;
}
.images {
  width: 100%;
  height: max-content;
  max-height: max-content;
  min-height: 100px;
  padding: 3px;
  display: flex;
  margin-top: 5px;
  overflow-x: auto;
  flex-wrap: wrap;
}
.images .image {
  position: relative;
  width: calc(100% / 3 - 10px);
  min-width: 150px;
  height: 200px;
  cursor: pointer;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 5px;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.images .image .delete-bar {
  margin-top: 10px;
  width: 100%;
  height: 30px;
  background-color: rgb(145, 3, 3);
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  border-radius: 5px;
}
.images .image img {
  max-width: 100%;
  max-height: calc(100% - 40px);
  border-radius: 5px;
  object-fit: contain;
}
.upload-btn {
  width: 30%;
}

@media screen and (max-width: 600px) {
  .container {
    justify-content: unset;
    overflow: hidden;
    background: var(--secondary);
    color: #fff;
  }
  .warpper {
    width: 100%;
    border: none;
    overflow-y: auto;
    flex-shrink: 0;
  }
  .send-btn {
    width: 100%;
  }
  .upload-btn {
    width: 100%;
  }
}
</style>
